/* ===========================================================================
   DEV AASTHA — PDP STORY SECTION             (assets/da-story.js)
   ---------------------------------------------------------------------------
   Teen kaam:
     1. Reveal animation — EK BAAR, wapas nahi
     2. Video — muted autoplay + loop, dikhne par chale, hatne par ruke
     3. Tap to unmute

   ⚠⚠ SABSE ZAROORI BAAT (owner ki "page shaking" wali shikayat isi parivaar ki
     hai): observer `is-in` lagane ke baad TURANT `unobserve` karta hai. Agar
     ise dono taraf toggle kiya jaye, to dheere scroll karte waqt threshold ke
     aas-paas har card baar-baar fade in/out hoga — aur wo bilkul "hilne" jaisa
     dikhta hai. Kabhi bhi `classList.remove('is-in')` mat likhna.

   ⚠ `dast-js` class turant lagti hai (DOMContentLoaded se PEHLE), taaki reveal
     ki shuruaati `opacity:0` first paint par hi lag jaye. Baad me lagane par
     content ek pal dikhkar phir gayab hota hai — khud ek flicker.
   ⚠ Agar ye file load hi na ho, to `.dast-reveal` par koi opacity nahi lagti
     (CSS `.dast-js` ke andar hai) — content saaf dikhta rehta hai. Fail-safe.
   =========================================================================== */

(function () {
  'use strict';

  document.documentElement.classList.add('dast-js');

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. REVEAL ---------------------------------------------------------- */
  function wireReveal(root) {
    var els = root.querySelectorAll('.dast-reveal:not(.is-in)');
    if (!els.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('is-in', 'is-done'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en, i) {
        if (!en.isIntersecting) return;
        var el = en.target;
        /* stagger, par 300ms se zyada nahi — warna neeche wale card ka intezaar
           dikhne lagta hai */
        var delay = Math.min(i * 70, 300);
        setTimeout(function () {
          el.classList.add('is-in');
          setTimeout(function () { el.classList.add('is-done'); }, 700);
        }, delay);
        io.unobserve(el);            /* ⚠ EK BAAR. Upar wala note padho. */
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  /* ---- 2 + 3. VIDEO ------------------------------------------------------- */
  function wireVideo(root) {
    var wraps = root.querySelectorAll('[data-dast-video]');

    Array.prototype.forEach.call(wraps, function (wrap) {
      if (wrap.dataset.dastReady === '1') return;
      wrap.dataset.dastReady = '1';

      var v = wrap.querySelector('video');
      if (!v) return;

      /* ⚠ Property se bhi set karo, sirf attribute par bharosa mat karo — kuch
         browser attribute ko baad me honour karte hain aur autoplay block ho
         jaata hai. */
      v.muted = true;
      v.defaultMuted = true;
      v.playsInline = true;

      var wantsPlay = wrap.dataset.autoplay !== 'false';

      function play() {
        if (!wantsPlay) return;
        var p = v.play();
        /* ⚠ play() ek Promise deta hai jo browser policy se reject ho sakta hai.
           Bina catch ke console me unhandled rejection aata hai. */
        if (p && p.catch) p.catch(function () {});
      }

      if (reduce || !('IntersectionObserver' in window)) {
        if (reduce) { v.controls = true; return; }
        play();
        return;
      }

      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) play();
          else if (!v.paused) v.pause();      /* screen se bahar — battery/data bachao */
        });
      }, { threshold: 0.35 });
      vio.observe(v);

      /* tap to unmute */
      var btn = wrap.querySelector('[data-dast-sound]');
      if (!btn) return;
      btn.setAttribute('data-muted', 'true');

      btn.addEventListener('click', function () {
        v.muted = !v.muted;
        btn.setAttribute('data-muted', String(v.muted));
        btn.setAttribute('aria-label', v.muted ? 'Unmute video' : 'Mute video');
        btn.setAttribute('aria-pressed', String(!v.muted));
        if (!v.muted) play();
      });
    });
  }

  function init(root) {
    root = root || document;
    try { wireReveal(root); } catch (e) {}
    try { wireVideo(root); }  catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  /* ⚠ Theme editor section ko dobara render karta hai — uske baad naye DOM par
     observers dobara lagane padte hain, warna editor me preview mara hua lagta
     hai aur banda samajhta hai ki feature toota hua hai. */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var vids = (e.target || document).querySelectorAll('[data-dast-video] video');
    Array.prototype.forEach.call(vids, function (v) { try { v.pause(); } catch (err) {} });
  });
})();
